module.exports = new __parcel__URL__("powerstrike.932dd4fd.png").toString();